import { render, staticRenderFns } from "./edit-data-view-modal.vue?vue&type=template&id=112b3007&scoped=true"
import script from "./edit-data-view-modal.vue?vue&type=script&lang=js"
export * from "./edit-data-view-modal.vue?vue&type=script&lang=js"
import style0 from "./edit-data-view-modal.vue?vue&type=style&index=0&id=112b3007&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112b3007",
  null
  
)

export default component.exports